import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TaskByEmployee from '../components/TaskByEmployee';
import { selectTaskSlice, viewPlans } from '../redux/slice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { format } from 'date-fns';

export default function ViewPlan() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const date = searchParams.get('date');

  const [plans, setPlans] = useState({});
  const dispatch = useDispatch();
  const { loading } = useSelector(selectTaskSlice);

  const transformedTasks = (list) => {
    return list.reduce((acc, task) => {
      const userId = task.user.id;
      if (!acc[userId]) {
        acc[userId] = {
          user: task.user,
          tasks: []
        };
      }
      acc[userId].tasks.push(task);
      acc[userId].tasks.sort((a, b) => {
        return (b.is_highlight === true) - (a.is_highlight === true);
      });

      return acc;
    }, {});
  };

  const handleViewPlan = (date) => {
    const payload = {
      plan_date: date
    };

    dispatch(viewPlans(payload)).then((res) => {
      if (res?.payload?.success) {
        const data = res.payload.data;
        setPlans(transformedTasks(data));
      }
    });
  };

  useEffect(() => {
    if (date) {
      handleViewPlan(date);
    } else {
      navigate('/plans', { replace: true });
    }
  }, [date]);

  return (
    <Layout sider={false}>
      {loading ? (
        <Spin className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" />
      ) : (
        <div className="flex flex-col gap-6 pb-6">
          {/* header */}
          <div className="flex items-center justify-between gap-1 ">
            <label
              className={'!text-base !m-0 md:!text-3xl !font-bold md:mt-0 mt-2'}
            >
              View Plan / {format(date, 'MMMM dd, yyyy')}
            </label>

            <CustomButton type="outlined" onClick={() => navigate('/plans')}>
              <ArrowLeftOutlined /> Back to Plans
            </CustomButton>
          </div>

          {/* tasks by employee */}
          <div
            className="flex flex-col gap-4 p-2 bg-white rounded-lg md:p-3"
            style={{ border: '1px dashed #e5e7eb' }}
          >
            {Object.entries(plans).map(([id, plan]) => {
              return (
                <TaskByEmployee
                  key={id}
                  plan={plan}
                  onRefresh={() => handleViewPlan(date)}
                />
              );
            })}
          </div>
        </div>
      )}
    </Layout>
  );
}
